import { ReactNode } from "react";

interface MetricCardProps {
  label: string;
  value: string | number;
  icon?: ReactNode;
  change?: {
    value: number;
    label: string;
  };
  emphasis?: "default" | "success" | "warning" | "danger" | "primary";
}

function MetricCard({ label, value, icon, change, emphasis = "default" }: MetricCardProps) {
  const getChangeClass = () => {
    if (!change) return "";
    if (change.value > 0) return "positive";
    if (change.value < 0) return "negative";
    return "neutral";
  };

  const formatValue = (val: string | number): string => {
    if (typeof val === "number") {
      if (val >= 1000000) return `${(val / 1000000).toFixed(1)}M`;
      if (val >= 1000) return `${(val / 1000).toFixed(1)}K`;
      return val.toLocaleString();
    }
    return val;
  };

  return (
    <div className={`metric-card ${emphasis !== "default" ? `metric-${emphasis}` : ""}`}>
      <div className="metric-card-header">
        <span className="metric-label">{label}</span>
        {icon && <span className="metric-icon">{icon}</span>}
      </div>
      <div className="metric-value">{formatValue(value)}</div>
      {change && (
        <div className={`metric-change ${getChangeClass()}`}>
          {change.value > 0 ? "↑" : change.value < 0 ? "↓" : "→"}{" "}
          {Math.abs(change.value).toFixed(1)}% {change.label}
        </div>
      )}
    </div>
  );
}

export default MetricCard;
